export default __webpack_public_path__ + "static/I-Remembered-eff27fd1b77f58d2e9e361a457a6a913.webp";